export default "__VITE_ASSET__DFbV5uxY__"